import { useState } from 'react';
import {  useToast } from "@chakra-ui/react"
import { useQueryClient, useMutation , useQuery} from "@tanstack/react-query"
import createCoupon from "services/Admin/Coupon/createCoupon"
import deleteCoupon from "services/Admin/Coupon/deleteCoupon"
import updateCoupon from "services/Admin/Coupon/editCoupon"
import allCoupons from "services/Admin/Coupon/getCoupon"
import verifyCoupon from "services/Admin/Coupon/verifyCoupon"
import useBillingContext from 'pages/UserDashboard/Billing/hooks/useBillingContext';

export const useCreateCoupon = () =>{
    const toast = useToast()
    const queryClient = useQueryClient()

    const onSuccess = () => {
        toast({title:"Coupon created!!", status:"success"})
        queryClient.invalidateQueries(['getAllCoupons']);
    }

    const onError = () => {
        toast({title:"Coupon not created.", status:"error"})
    }

    const {mutateAsync, isLoading} = useMutation(createCoupon, { onSuccess, onError })
    return { create: mutateAsync, isLoading }
}

export const useGetAllCoupons= (payload: any) => {
    const toast = useToast();
    const onError = () => {
      toast({ title: "No Coupons Found", status: "error" });
    };
  
    const {  data, isLoading, refetch } = useQuery(
      ["getAllCoupons", payload],
      () => allCoupons(payload),
      { onError }
    );
  
    return { coupons: data?.coupons, total: data?.total, isLoading ,refetch };
};

export const useUpdateCoupon = () => {
    const toast = useToast();
    const queryClient = useQueryClient()
    
    const onSuccess = (token:  string) => {
        toast({ title: "Coupon Updated Successfully", status: "success" });
        queryClient.invalidateQueries(['getAllCoupons']);
    }
    
    
    const onError = () => {
        toast({ title: "Coupon not updated", status: "error" });
    };
    const {mutateAsync, isLoading} = useMutation(updateCoupon,{onSuccess, onError});
    return{updateCoupon: mutateAsync, isLoading}
}

export const useDeleteCouponById = () => {
    const toast = useToast();
    const queryClient = useQueryClient()

    const onSuccess = () => {
        toast({ title: "Coupon deleted!!", status: "success" });
        queryClient.invalidateQueries(['getAllCoupons']);

    };

    const onError = () => {
        toast({ title: "Error deleting coupon.", status: "error" });
    };

    const { mutate, isLoading } = useMutation(deleteCoupon, {
        onSuccess,
        onError,
    });

    const couponDelete = (couponId: string) => {
        mutate({ couponId });
    };

    return {  couponDelete, isLoading };
}

export const useVerifyCoupon = () => {
    const toast = useToast();
    const [data, setData]= useState()
    const { setCouponData } = useBillingContext()


    const onSuccess = (data: any) => {
        toast({ title: "Coupon is valid!!", status: "success" })
        setData(data)
        setCouponData?.(data?.discount, data?.type)
    };

    const onError = (data: any) => {
        toast({ title: data?.response?.data?.error ? data?.response?.data?.error : "Coupon is not valid", status: "error" });
    };

    const { mutate, isLoading } = useMutation(verifyCoupon, {
        onSuccess,
        onError,
    });

    const couponVerify = (couponId: string, planId: number) => {
        mutate({ couponId, planId });
    };

    return {  couponVerify, dataCoupon: data,  isLoading };
}